import PageShell from '@/components/feature/PageShell';
import PageHero from '@/components/feature/PageHero';
import { doctors } from '@/mocks/home';
import { fetchDoctorList } from '@/services/doctor';
import { adaptDoctors } from '@/services/adapters';
import { useRequest } from '@/hooks/useRequest';
import DoctorDirectory from '@/pages/doctors/components/DoctorDirectory';

const HERO_IMAGE =
  'https://readdy.ai/api/search-image?query=Warm%20professional%20scene%20of%20a%20senior%20Chinese%20medicine%20doctor%20consulting%20with%20a%20patient%20in%20a%20bright%20elegant%20clinic%2C%20soft%20natural%20light%2C%20warm%20beige%20tones%2C%20dark%20soft%20lower%20area%20for%20text%20overlay%2C%20editorial%20photography&width=1920&height=560&seq=doctors-hero&orientation=landscape';

export default function DoctorsPage() {
  // 接口失败时降级为 mock 数据
  const { data } = useRequest(
    () => fetchDoctorList({ pageIndex: 1, pageSize: 999 }).then((res) => adaptDoctors(res.list)),
    { fallback: doctors },
  );

  return (
    <PageShell>
      <PageHero
        image={HERO_IMAGE}
        eyebrow="医师团队"
        title="名老中医与骨干医师"
        description="汇聚国家级名老中医与三甲医院骨干医师，以中西医结合之力守护全周期健康，让名医经验可寻、可学、可信赖。"
        breadcrumb={[{ label: '首页', to: '/' }, { label: '医师团队' }]}
      />

      <DoctorDirectory items={data} />
    </PageShell>
  );
}